"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserRoleEnum = void 0;
/**
 * Роль пользователя
 */
var UserRoleEnum;
(function (UserRoleEnum) {
  /** Обычный пользователь */
  UserRoleEnum[UserRoleEnum["user"] = 1] = "user";
  /** Модератор пользователей и контента */
  UserRoleEnum[UserRoleEnum["moderator"] = 2] = "moderator";
  /** Редактор контента */
  UserRoleEnum[UserRoleEnum["editor"] = 3] = "editor";
  /** Переводчик */
  UserRoleEnum[UserRoleEnum["translator"] = 4] = "translator";
  /** тестировщик - для новых фич */
  UserRoleEnum[UserRoleEnum["tester"] = 5] = "tester";
  /** разработчик */
  UserRoleEnum[UserRoleEnum["developer"] = 6] = "developer";
})(UserRoleEnum = exports.UserRoleEnum || (exports.UserRoleEnum = {}));
